@if (showContent()) {
  @if (note()) {
    <app-content-shell [contentId]="note().content_id" [settings]="note()?.settings" (settingsChanged)="updateSettings($event)">
      <app-content-display-card [contentID]="note().content_id" [settings]="note()?.settings" (updateSettings)="updateSettings($event)">
        <ng-template #header>
          @if (!isReader()) {
            <app-audio-recorder [params]="chunk" [showAudioButton]="true" [contentID]="note().content_id" [origin]="'note'" [showTranscribeButton]="true" [compact]="isCompact()" (click)="contentStateService.pauseAudio()" />
          }
        </ng-template>
        <ng-template #headerActions>
          <app-float-edit-menu type="note" [contentID]="note().content_id" [note]="note()" [noteID]="note()._id" [aiAssistantDisplay]="'icon'" [searchDisplay]="'icon'" [syncContentDisplay]="'icon'"></app-float-edit-menu>
        </ng-template>
        <ng-template #body>
          <app-content [note]="note()" [readMode]="'true'" [noteID]="note()._id" [contentID]="note().content_id" [contentName]="note().name" [contentType]="'note-post'" [from]="'note'"></app-content>
        </ng-template>
      </app-content-display-card>
    </app-content-shell>
  }
}
